export const ListQueryKey = 'feedbacks';
export const DetailQueryKey = 'feedback';

export const Urls = {
  selectUrl: '/feedback/list',
  updateUrl: '/feedback/update',
  deleteUrl: '/feedback/delete',
  createUrl: '/feedback/create',
  detailUrl: '/feedback/info',
};
// /api/feedback/list
